var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "wrap-view-more" }, [
    _c(
      "button",
      {
        staticClass: "flat with-border",
        style: `
      width: 100%;
      height: 100%;
      --button-font-weight: var(--font-weight-normal);
      --button-background: transparent;
      --button-hover-background: var(--fa-navy);
      --button-hover-color: var(--white);
      --button-margin-bottom: 0`,
        on: {
          click: function ($event) {
            return _vm.$emit("viewMore", {
              family: _vm.selectedFamily,
              style: _vm.selectedStyle,
            })
          },
        },
      },
      [
        _c("span", { staticClass: "margin-right-2xs" }, [
          _vm._v(_vm._s(_vm.currentLabel)),
        ]),
        _vm._v(" "),
        _c(
          "span",
          [
            _c("font-awesome-icon", {
              attrs: {
                icon: _vm.$v6.solid.faArrowRight,
                "fixed-width": "",
                size: "lg",
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }